import React from 'react';
import { message, Modal, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import book_see_chat_1 from '../img/JungRakCharacter/07.png';
function UserMessage(props) {
	const timer = () => {
		let today = new Date();
		let hour = today.getHours();
		let minute = today.getMinutes();
		let ampm = '';
		let timeResult = '';
		ampm = hour >= 12 ? '오후' : '오전';
		hour = hour >= 12 ? hour - 12 : hour;
		hour = hour === 0 ? 12 : hour;
		minute = minute >= 0 && minute <= 9 ? '0' + minute : minute;
		timeResult = `${ampm} ${hour}:${minute}`;

		return timeResult;
	};

	return (
		<div>
			<div className="chat--log user">
				<i>
					{
					  <Avatar
					  style={{
						backgroundColor: '#87d068',
					  }}
					  icon={<UserOutlined />}
					/>
					 }
					{/* <MessageTwoTone style={{fontSize :35}} onClick={()=> message.success('Chatbot이 말합니다.')} alt="챗봇"/> */}
				</i>
				<div className="chat" style={{ cursor: 'pointer' }} onClick={() => message.success('User가 말합니다.')}>
					{props.params.Text}
				</div>
				<div className="chat-time">
					<span>{timer()}</span>
				</div>
			</div>
		</div>
	);
}

export default UserMessage;
